// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Spinner__overlay__2dww2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/Spinner.scss
// module id = 638
// module chunks = 0